/* eslint eqeqeq: 'off' */
import React, { Component } from "react";
import { connect } from "react-redux";
import '../../../../../../Assets/EnsembleStyles/EnsTenantServicesFeaturebar.css';
import '../../../../../../Assets/EnsembleStyles/ViewTenantDetails.css';
import classnames from 'classnames';
import { PutAfterHoursAction } from '../../../../../../action/tenantAction';
import Currencies from '../../../../../../Resources/Currencies';
import ErrorGif from '../../../../../../Assets/images/Error.gif';
import { Col, Button,FormGroup, Label, Table, Modal } from 'reactstrap';
import Conversions from '../../../../../../Resources/Conversions';

let lstZonesRates = [];
class EditAfterHours extends Component {

  constructor(props) {
    super(props);
    this.state = {
    TenantID :this.props.AfterHours_response.tenantId,
    RatePerHour :this.props.AfterHours_response.ratePerHour,
    MinmumAfterHour :this.props.AfterHours_response.minmumAfterHour,
    RounderHours :this.props.AfterHours_response.rounderHours,
    Zones :this.props.AfterHours_response.zones,
    FacilitySetup:this.props.AfterHours_response.facilitysetup,
    HasZoneRate:this.props.AfterHours_response.hasZoneRate,
    ToEmailAddress:"",
    modal: false,
    IsModalClose:false,
    tenant_zones: this.props.TenantZones_response,
    AdditionalMail:!this.props.AfterHours_response.facilitysetup.sendToAdditionalRecipient,
    currencyId:this.props.CompanyInformation_response.currencyId,
    UserPreferenceFormat:[],
    IsZoneRateErr: false
    };
    this.returnToView = this.returnToView.bind(this);
    this.onCostChanged = this.onCostChanged.bind(this);
    this.toggle = this.toggle.bind(this);
    this.onSaveRates = this.onSaveRates.bind(this);
    this.toggleEmail = this.toggleEmail.bind(this);
  }

  toggleEmail(){
    this.setState({AdditionalMail: !this.state.AdditionalMail});
  }

  onSaveRates(Rows){
    lstZonesRates = [];    
    let IsValid = true;
    for(let i=0; i < Rows.length; i++){
        var id=Rows[i].props.children[0].props.children[0].ref; 
        let ZoneId = Rows[i].props.children[0].props.children[0].props.id;
        let ZoneName = Rows[i].props.children[2].props.children;
        let ZoneRate = Conversions.getInvariantNumberForAH(this.state.UserPreferenceFormat,this.refs[id].value);

        if(ZoneRate != null && ZoneRate != "" && ZoneRate !== "NaN"){
            let NumberFormat = /^[0-9\b.]+$/;
            if(!NumberFormat.test(ZoneRate)){
                IsValid = false;
            }
        }else{
          if(ZoneRate !== 0)
            IsValid = false;
        }
        
        lstZonesRates.push({zoneId:ZoneId,zoneName:ZoneName,Rate:ZoneRate});
    }
    if(IsValid){
        var lstRates = [];
        lstZonesRates.map(el => (
            lstRates.push({"zoneId":el.zoneId,"rate":Number(el.Rate)})
        ));
        this.setState({modal: !this.state.modal,Zones: lstRates});
    }else{
        this.setState({modal: this.state.modal, IsZoneRateErr : true});
    }
}


  
EditAfterHoursPUT() {
  let IsValid = true;
  this.setState({IsModalClose: true});
  
  let Rate_Per_Hour = Conversions.getInvariantNumberForAH(this.state.UserPreferenceFormat,this.refs.Cost_Per_Hour.value);
  let Minimum_AfterHr = this.refs.Minimum_Request_Input.options.selectedIndex; 
  let Minimum_Hr = this.refs.Minimum_Request_Input.options[Minimum_AfterHr].value;
  let Rounder_Hour = this.refs.Roundup_Nearest_Input.options.selectedIndex; 
  let Round_Hr = this.refs.Roundup_Nearest_Input.options[Rounder_Hour].value;
  let Has_ZoneRate = this.refs.Zone_Cost.checked;
  

  if(Rate_Per_Hour != null && Rate_Per_Hour != "" && Rate_Per_Hour !== "NaN"){
      let NumberFormat = /^[0-9\b.]+$/;
      if(!NumberFormat.test(Rate_Per_Hour)){
          IsValid = false;
          this.setState({IsModalClose: true});
      }
  }else{
    if(Rate_Per_Hour !== 0){
      IsValid = false;
      this.setState({IsModalClose: true});
    }
  }
  if(this.refs.SendTo_Additional_Recipient.checked){
      if(this.refs.Facility_Request_Email.value == null || this.refs.Facility_Request_Email.value == ""){
          IsValid = false;
          this.setState({IsModalClose: true});
      }
      let Email = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      var EmailIds = this.refs.Facility_Request_Email.value; 
      var Ids = EmailIds.split(';');
      for(let i=0; i<Ids.length; i++){
          var MailId = Ids[i].trim();
          if(MailId !== "" && !MailId.match(Email)){
              IsValid = false;
              this.setState({IsModalClose: true});
          }
      }
  }

  
  
  if(IsValid){
      let lstEmail = [];
      if(this.refs.SendTo_Additional_Recipient.checked && this.refs.Facility_Request_Email.value != null){
          lstEmail = (this.refs.Facility_Request_Email.value).split(';');
      }
      let Facility_Setup = {"SendToRequestedEmployee":this.refs.SendTo_Requested_Employee.checked,"SendToAdditionalRecipient":this.refs.SendTo_Additional_Recipient.checked,"ToEmailAddress":lstEmail};
      if(Minimum_Hr ==="Select"){
        Minimum_Hr = null;
      }
      if(Round_Hr ==="Select"){
        Round_Hr = null;
      }
     
      var data = {
          "HasAfterHoursOption": true,
          "RatePerHour"  : Rate_Per_Hour,
          "MinmumAfterHour"  : Minimum_Hr,
          "RounderHours"  : Round_Hr,
          "HasZoneRate"  : Has_ZoneRate,
          "Zones" : lstZonesRates,
          "FacilitySetup" : Facility_Setup
      }

      var tenant_Id = this.state.TenantID
      this.props.PutAfterHoursAction(data,tenant_Id);
      this.returnToView();
  }
}

onCostChanged(){
  if(!this.refs.Zone_Cost.checked){
      this.setState({ HasZoneRate: false });
  }else{
      this.setState({ HasZoneRate: true });
  }
}

handleChange = (event) => {
  this.setState({
    SelectedMinReqHrs: event.target.value
});
  if(event.target.value === "Select"){
      this.setState({Isdisable : true});
      this.setState({
          SelectedRoundup: "Select"
      });
  }
  
  else{
      this.setState({Isdisable : false});
  }
 
}

handleChange1 = (event) => {
  this.setState({
      SelectedRoundup: event.target.value
  });
}


componentWillReceiveProps(nextProps) {
  if(this.props != nextProps) {
    this.setState({  
      TenantID : nextProps.AfterHours_response.tenantId,
      RatePerHour :nextProps.AfterHours_response.ratePerHour,
      MinmumAfterHour :nextProps.AfterHours_response.minmumAfterHour,
      RounderHours :nextProps.AfterHours_response.rounderHours,
      Zones :this.props.AfterHours_response.zones,
      FacilitySetup:this.props.AfterHours_response.facilitysetup,
      HasZoneRate:this.props.AfterHours_response.hasZoneRate,
      tenant_zones: nextProps.TenantZones_response,
      currencyId: nextProps.CompanyInformation_response.currencyId,
      AdditionalMail: !nextProps.AfterHours_response.facilitysetup.sendToAdditionalRecipient
      });
  }
  
}

componentDidMount() {
    if(this.props.UserPreference_response !== undefined && this.props.UserPreference_response !== null){
        this.setState({UserPreferenceFormat:this.props.UserPreference_response})
    }
  if(!this.state.HasZoneRate){
    this.refs.Cost_Per_Hour.value = this.state.RatePerHour;
    }
    this.refs.Minimum_Request_Input.value = this.state.MinmumAfterHour === null || this.state.MinmumAfterHour === 0 ? "Select" :  Number(this.state.MinmumAfterHour).toFixed(1);
    this.refs.Roundup_Nearest_Input.value = this.state.RounderHours === null || this.state.RounderHours === 0 ? "Select" : Number(this.state.RounderHours).toFixed(1);
    if(this.state.RounderHours === null || this.state.RounderHours === 0){
      if(this.state.MinmumAfterHour === null || this.state.MinmumAfterHour === 0)
      this.setState({Isdisable : true});
    }
}

toggle() {
  this.setState({
      modal: !this.state.modal
  });
}
  

returnToView(){
  this.props.Display("value");
}

          // View or Edit or state

    render(TenantZones_response,CompanyInformation_response,getLabels,UserPreference_response) {
      let label = this.props.getLabels;
      let errormsg1;
      if(this.state.IsModalClose){
        var errormsg = <p  className="error_msg">
                        <img src={ErrorGif} alt="Trane Logo" /> 
                        Error: You left necessary fields blank or entered invalid values.
                        </p> 
       }
       if(this.state.IsZoneRateErr){
        errormsg1 = <p  className="error_msg">
                        <img src={ErrorGif} alt="Trane Logo" /> 
                        Error: You left necessary fields blank or entered invalid values.
                        </p> 
    }
    let Available_Zones, modal_form_1;
    let PreferedDateFormat = this.props.UserPreference_response;
    if (this.state.tenant_zones != null) {
        if (this.state.tenant_zones.length) { 
          lstZonesRates = [];
            Available_Zones = this.state.tenant_zones.map(el => {
                var Value = this.state.Zones.filter(xl => (xl.zoneId == el.zoneId))[0];
                var Rate = Conversions.formatNumber(PreferedDateFormat,'50.00');
                if(Value != undefined){
                    var Rates = Value.rate;
                    if(Rates != undefined && Rates != null && Rates >= 0)
                        Rate = Rates;
                }
                lstZonesRates.push({zoneId:el.zoneId,zoneName:el.zoneName,Rate:Rate});
                    return    <tr>
                            <td style={{"font-family":"Arial"}}><input type="text" id={el.zoneId} ref={'ref_' + el.zoneId} defaultValue={Rate}/>&nbsp;{Currencies.CurrenciesList(this.state.currencyId)}</td>
                            <td>{el.buildingName}</td>
                            <td>{el.zoneName}</td>
                            <td>{el.members.map(xl => (xl.objectName)).join(', ')}</td>
                        </tr>
        });
        }
        else{
          Available_Zones = <tr> <td colSpan="4">No Records Found</td> </tr>
        }
    }
    modal_form_1 =  <div className="table_container">
                    <legend className="form_sub_title">Edit After-Hours Costs by Zone </legend>
                    {errormsg1}
                    <Table striped responsive className="Custom_table table_border">
                    <tbody className="cell_container tenant_cell">
                        <tr>
                            <th>{label['CreateTenant.ViewAfterHoursHourlyRate.Text'] !== undefined ? label['CreateTenant.ViewAfterHoursHourlyRate.Text'] : "Cost per Hour"}</th>
                            <th>{label['SubGroups.Columns.SiteName.Text'] !== undefined ? label['SubGroups.Columns.SiteName.Text'] : "Building"}</th>
                            <th>{label['TenantZones.Zone.Text'] !== undefined ? label['TenantZones.Zone.Text'] : "Zone"}</th>
                            <th>{label['TenantZones.Members.Text'] !== undefined ? label['TenantZones.Members.Text'] : "Members"}</th>                                
                        </tr>
                        {Available_Zones}
                    </tbody>
                    </Table>
                    <FormGroup row className="btns_group">
                        <Col sm={{ size: 10 }}>
                            <Button className="btn-gray btn-md" onClick={this.toggle}> Cancel </Button>
                            <Button className="btn-success btn-md" onClick={() => this.onSaveRates(Available_Zones)}>Apply</Button>
                        </Col>
                    </FormGroup>
                    </div>

      return (

        <div className="main_container">
           {errormsg}
            <legend className="form_sub_title">After-Hours Billing Agreement </legend>

            <div className="form_group ">
              <Label className="Custom_label_small_width">Cost per Hour*</Label>
            </div>
            <br />

            <div className="form_group">
               <table>
                <tr>
                    <td>
                    <input type="radio" ref="Same_Cost" name="rdCost1" defaultChecked={!this.state.HasZoneRate} onChange={this.onCostChanged} /> Same cost for all zones
                    </td>
                    <td style={{"font-family":"Arial","padding-left":"89px"}}>
                    <input className="custom_input default-input input_small_width" type="text" ref="Cost_Per_Hour" defaultValue={Conversions.formatNumber(PreferedDateFormat,'50.00')} />&nbsp;{Currencies.CurrenciesList(this.state.currencyId)}
                    </td>
                </tr>
               </table> 
            </div>

            <div className="form_group" style={{"margin-bottom":"16px"}}>
              <input type="radio" ref="Zone_Cost" name="rdCost1" defaultChecked={this.state.HasZoneRate}  value="1" onChange={this.onCostChanged} /> Different costs for different zones
              <Button className="btn-black btn-md" style={{"margin-left":"30px"}} ref="btnEditCost" disabled={!this.state.HasZoneRate} onClick={this.toggle}>Edit Cost</Button>
            </div>

            <div className="form_group">
               <Label className="Custom_label_small_width">Minimum Request</Label>
               <select ref='Minimum_Request_Input' onChange={this.handleChange} value={this.state.SelectedMinReqHrs}  className="custom_input default-input select_small_width">Hour
                    <option>Select</option>
                    <option value="0.5">{Conversions.formatNumberAHrs(PreferedDateFormat,'0.5')}</option>
                    <option value="1.0">{Conversions.formatNumberAHrs(PreferedDateFormat,'1.0')}</option>
                    <option value="1.5">{Conversions.formatNumberAHrs(PreferedDateFormat,'1.5')}</option>
                    <option value="2.0">{Conversions.formatNumberAHrs(PreferedDateFormat,'2.0')}</option>
                    <option value="2.5">{Conversions.formatNumberAHrs(PreferedDateFormat,'2.5')}</option>
                    <option value="3.0">{Conversions.formatNumberAHrs(PreferedDateFormat,'3.0')}</option>
               </select>
               <span className="Custom_label_small_width" style={{"padding-left":"15px"}}>Hour</span>
           </div>

           <div className="form_group">
               <Label className="Custom_label_small_width">Round Up to Nearest</Label>
               <select ref='Roundup_Nearest_Input'  onChange={this.handleChange1} disabled={this.state.Isdisable} value={this.state.SelectedRoundup} className="custom_input default-input select_small_width">Hour
                    <option>Select</option>
                    <option value="0.5">{Conversions.formatNumberAHrs(PreferedDateFormat,'0.5')}</option>
                    <option value="1.0">{Conversions.formatNumberAHrs(PreferedDateFormat,'1.0')}</option>
                    <option value="1.5">{Conversions.formatNumberAHrs(PreferedDateFormat,'1.5')}</option>
                    <option value="2.0">{Conversions.formatNumberAHrs(PreferedDateFormat,'2.0')}</option>
                    <option value="2.5">{Conversions.formatNumberAHrs(PreferedDateFormat,'2.5')}</option>
                    <option value="3.0">{Conversions.formatNumberAHrs(PreferedDateFormat,'3.0')}</option>
               </select>
               <span className="Custom_label_small_width" style={{"padding-left":"15px"}}>Hour</span>
            </div>

            <div className="clear">&nbsp;</div>
            <legend className="form_sub_title">Facility Request E-mail Notification</legend>
            <div className="form_group form_group_textare">
              <FormGroup check>
                <Label check>
                  <input type="checkbox" defaultChecked={this.state.FacilitySetup.sendToRequestedEmployee} ref="SendTo_Requested_Employee" id="AfterHours"  />{' '}
                  Send e-mail confirmation to the Tenant Employee who created or modified a Facility Request
                                                      </Label>
              </FormGroup>
              <FormGroup check>
                <Label check>
                  <input type="checkbox" onChange={this.toggleEmail}  defaultChecked={this.state.FacilitySetup.sendToAdditionalRecipient} ref="SendTo_Additional_Recipient" id="MeterCharges" />{' '}
                  Send e-mail notification for every Facility Request or modification to:
                                                      </Label>
              </FormGroup>
            </div>
            <div className="form_group form_group_textarea">
              {/* <input className="custom_input default-input" disabled={this.state.AdditionalMail} ref="Facility_Request_Email" type="textarea" name="Company Name" defaultValue={this.state.FacilitySetup.toEmailAddress.join(';')} /> */}
              <textarea ref="Facility_Request_Email" rows="5" style={{"width": "500px"}} disabled={this.state.AdditionalMail} className="custom_input default-input" defaultValue={this.state.FacilitySetup.toEmailAddress.join(';')} />

            </div>
            <div className="form_group form_group_textarea">
              <Label >Type additional addresses using semi-colons to separate each address.
                                </Label>
            </div>

            {/* Actions Buttons    */}

            <FormGroup row className="btns_group">
              <Col sm={{ size: 10 }}>
                <Button className="btn-gray btn-md" onClick={ this.returnToView } > Cancel </Button>
                <Button className="btn-success btn-md" onClick={() => { this.EditAfterHoursPUT() }}>Save </Button>
              </Col>
            </FormGroup>
            <Modal isOpen={this.state.modal} toggle={this.toggle} className={classnames({ classnames: this.props.className }, "ModalContainer")} >
                    {modal_form_1}
              </Modal> 
          </div>

      );
    }
    }

const mapStateToProps = state => {
  return {
    AfterHours_response: state.ViewtenantsRootReducer.AfterHours,
    getLabels: state.CulturalLabelsRootReducer.LabelsBasedOnPreference,
    CompanyInformation_response: state.ViewtenantsRootReducer.CompanyInformation,
    TenantZones_response: state.ViewtenantsRootReducer.TenantZones,
    UserPreference_response: state.userPreferencesRootReducer.UserPreference
  };
};
const mapDispatchToProps = dispatch => {
  return {
    PutAfterHoursAction: (AfterHourseditData, tenant_Id) => dispatch(PutAfterHoursAction(AfterHourseditData, tenant_Id)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(EditAfterHours);

